import { http, cInfrastructures } from "@di";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
import understandUseCases from "../../understandingCommonDI/understandUseCases";
const understandUseCase = understandUseCases();
const cRepositorires = repositories(http, cInfrastructures);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions, understandUseCase);
export default {
    pnlReport: cPresenters.pnlReport,
    pnlTransactionReport: cPresenters.pnlTransactionReport,
};
